"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isFunction;
/**
 * Checks whether or not a value is a function.
 *
 * @param {any} value evaluate if function
 * @returns {boolean} isFunction
 */
function isFunction(value) {
  // eslint-disable-next-line eqeqeq
  return !!(value && {}.toString.call(value) == '[object Function]');
}